import React from 'react';
import * as boardsStore from '../../extensions/bundled/task-manager/boardsStore';
import { progressPercent } from '../../extensions/bundled/task-manager/boardsOverview';
import BoardTileMenu from './BoardTileMenu';
import { BoardScopeChip, BoardLocationChip, BoardProgress, BoardOverdueChip } from './BoardTileParts';
import { boardBackground } from '../../extensions/bundled/task-manager/boardColorValue';
import { isNeutralBoardColor } from './boardColor';
import './BoardsOverview.css';

/**
 * The overview's row view (card 7.2 stretch goal): one line per board —
 * colour dot, name, the tile's Personal / team and Cloud / This device chips,
 * progress, overdue, last opened, and the same ⋯ menu as the tile. Every
 * cell is always rendered (owner, 13.10.2026): a personal cloud board used to
 * have no scope cell, so its progress slid into the narrow `auto` column and
 * the bar collapsed to nothing. Takes the per-board
 * props from the same `tileProps` builder the card grid uses, so gating can
 * never differ between the two views.
 */
export default function BoardsRowList({ items }) {
  return (
    <div className="boards-rows" role="list" aria-label="Boards">
      {items.map(({ key, props }) => {
        const { board, teamLabel, onOpen, openedLabel } = props;
        const isTeam = board.visibility === 'team';
        const onDevice = !isTeam && board.location === boardsStore.LOCATION_DEVICE;
        return (
          <div key={key} role="listitem" className="boards-row" data-board-id={board.id} onClick={() => onOpen(board)}>
            <button
              type="button"
              className="boards-tile-open"
              aria-label={`Open board ${board.name}`}
              onClick={(e) => {
                e.stopPropagation();
                onOpen(board);
              }}
            />
            <span className={`boards-row-dot${isNeutralBoardColor(board.color) ? ' board-color-dot--neutral' : ''}`} style={{ background: boardBackground(board.color) }} aria-hidden />
            <span className="boards-row-name">{board.name}</span>
            <span className="boards-row-scope">
              <BoardScopeChip isTeam={isTeam} teamLabel={teamLabel} />
              <BoardLocationChip onDevice={onDevice} />
            </span>
            <span className="boards-row-progress">
              <BoardProgress done={board.doneCount || 0} total={board.taskCount || 0} percent={progressPercent(board)} />
            </span>
            <span className="boards-row-overdue">
              <BoardOverdueChip count={board.overdueCount || 0} />
            </span>
            <span className="boards-row-opened">{openedLabel || ''}</span>
            <BoardTileMenu {...props} onDevice={onDevice} />
          </div>
        );
      })}
    </div>
  );
}
